import React from 'react';
import Button from './Button';
import { BRAND_SHORT, brandify } from '../brandConfig';

const AboutPage = ({ navigate }) => {
  return (
    <div className="py-32 max-w-[95vw] mx-auto px-4 md:px-8 bg-background min-h-screen">
      <div className="max-w-4xl mx-auto mt-12 mb-20">
        <h1 
          className="text-4.5xl whitespace-nowrap sm:text-6xl md:text-8xl lg:text-9xl font-bold uppercase tracking-tighter leading-none mb-8 text-foreground"
          style={{ fontFamily: "'Poppins Black', sans-serif" }}
        >
          ABOUT {BRAND_SHORT}
        </h1>
        
        <div className="space-y-6 text-lg md:text-xl text-muted-foreground leading-relaxed font-medium">
          <p>
            {brandify('Wind Marketing is an agency built on speed, precision, and impact. We believe that in a crowded digital world, subtlety is a liability. Your brand deserves to be seen, heard, and remembered.')}
          </p>
          <p>
            We combine bold design with data-driven strategy to create digital experiences that don't just look good; they perform. Whether it's a high-converting website, an engaging social media campaign, or a complete brand overhaul, we move fast and deliver measurable results.
          </p>
        </div>

        <div className="flex flex-col sm:flex-row justify-center items-center gap-4 mt-12">
          <Button 
            size="large"
            onClick={() => navigate('/contact')}
          >
            Work With Us
          </Button>
          <Button 
            variant="outline" 
            size="large"
            onClick={() => navigate('/work')}
          >
            View Our Work
          </Button>
        </div>
      </div>
    </div>
  );
};

export default AboutPage;
